import React from 'react';
import { Box, CircularProgress, Link, Typography } from '@mui/material';
import Avatar from 'react-avatar';
import { ErrorOutline } from '@mui/icons-material';
import { styled } from 'theme';
import { FileUpload } from '../../store/slices/file';

const ErrorBox = styled(Box)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: theme.palette.background.paper,
    borderRadius: theme.shape.borderRadius,
    padding: theme.spacing(1),
    marginBottom: theme.spacing(1),
}));

const StyledErrorOutlineIcon = styled(ErrorOutline)(({ theme }) => ({
    marginRight: theme.spacing(1),
    color: theme.palette.error.main,
}));

const ErrorMessage = styled(Typography)(({ theme }) => ({
    color: theme.palette.error.main,
}));

const RetryLink = styled(Link)(({ theme }) => ({
    color: theme.palette.error.main,
}));

interface UploadFileProps {
    file: Partial<FileUpload>,
    label?: string,
}

const AvatarContainer = styled('div')(() => ({
    textAlign: 'center',
}));


export const FileUploadStatuses = {
    REQUESTED_UPLOAD: 'requested-upload',
    REQUESTED_UPLOAD_FAIL: 'requested-upload-fail',
    UPLOADING: 'uploading',
    UPLOADING_FAIL: 'uploading-fail',
    UPLOAD_FINISHING: 'upload-finishing',
    UPLOAD_FINISHING_FAIL: 'upload-finishing-fail',
    UPLOADED: 'uploaded',
    DELETING: 'deleting',
    DELETE_FAIL: 'delete-fail',
    DELETED: 'deleted',
} as const;

export const UploadFileAsLink: React.FC<UploadFileProps> = ({
    file,
    label
}) => {
    return (
        <>
            <AvatarContainer>
                {!file || [
                    FileUploadStatuses.UPLOADED,
                ].find((s) => s === file.status)?.length ?
                    <Avatar round name={label ?? ''} src={file ? file.url : null}/>
                    : null}
                {file && [
                    FileUploadStatuses.REQUESTED_UPLOAD,
                    FileUploadStatuses.UPLOADING,
                    FileUploadStatuses.UPLOAD_FINISHING,
                ].find((s) => s === file.status)?.length ?
                    <CircularProgress/>
                    : null}
                {file && [
                    FileUploadStatuses.REQUESTED_UPLOAD_FAIL,
                    FileUploadStatuses.UPLOADING_FAIL,
                    FileUploadStatuses.UPLOAD_FINISHING_FAIL,
                ].find((s) => s === file.status)?.length ?
                    <ErrorBox>
                        <StyledErrorOutlineIcon/>
                        <ErrorMessage variant={'caption'}>
                            Oops! File hiccup.
                            <br/>
                            <RetryLink
                                href={'#'}
                                onClick={(e) => {
                                    e.preventDefault();
                                }}
                            >
                                Try again
                            </RetryLink>
                        </ErrorMessage>
                    </ErrorBox>
                    : null}
            </AvatarContainer>
        </>
    );
};